import React from 'react';

interface IProps {
  type?: string;
  molyIcon: React.ReactNode;
}

const AccountSecurityIcon: React.FC<IProps> = ({ molyIcon }) => {
  return <div className="account-base-icon">{molyIcon}</div>;
};

export default AccountSecurityIcon;
